<ul class="facet-level">
    <li>
        <div class="node-title">
            <span class="toggle placeholder" *ngIf="!facetNode.isNested">
                <i class="fas fa-angle-double-right"></i>
            </span>
            <a
                class="toggle"
                (click)="onToggleClick(facetNode)"
                *ngIf="facetNode.isNested"
            >
                <span
                    class="toggle"
                    [ngClass]="{ visible: facetNode.isNested }"
                >
                    <i
                        class="fas"
                        [ngClass]="{
                            'fa-plus': !facetNode.expanded,
                            'fa-minus': facetNode.expanded
                        }"
                    ></i>
                </span>
            </a>
            <input
                type="checkbox"
                [id]="facetNode.facetId"
                [attr.data-gtmlabel]="facetNode.gtmLabel"
                [ngModel]="facetNode.checked"
                (change)="onCheckboxChange($event, facetNode)"
                [indeterminate]="facetNode.indeterminate"
            />
            <label [for]="facetNode.facetId">{{ facetNode.node.title }}</label>
        </div>
        <div *ngIf="facetNode.isNested && facetNode.expanded">
            <app-nested-facet-nodes
                [ngClass]="{ hidden: !facetNode.expanded }"
                *ngFor="let child of children"
                [facet]="facet"
                [facetNode]="child"
            ></app-nested-facet-nodes>
        </div>
    </li>
</ul>
